/**
 * @generated SignedSource<<0860bb63f6950f705202988bd2f9d8ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "documentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentId",
        "variableName": "documentId"
      },
      {
        "kind": "Variable",
        "name": "offerId",
        "variableName": "offerId"
      },
      {
        "kind": "Variable",
        "name": "teamId",
        "variableName": "teamId"
      }
    ],
    "concreteType": "DuplicateDocumentAndItsWidgetsMutationResponse",
    "kind": "LinkedField",
    "name": "duplicateDocumentAndItsWidgets",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CopiedDocumentData",
        "kind": "LinkedField",
        "name": "copiedDocument",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WidgetDates",
            "kind": "LinkedField",
            "name": "dates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastUpdate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DuplicateDocumentAndItsWidgetsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DuplicateDocumentAndItsWidgetsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c4ac239137d37207c92b75e8285cec89",
    "id": null,
    "metadata": {},
    "name": "DuplicateDocumentAndItsWidgetsMutation",
    "operationKind": "mutation",
    "text": "mutation DuplicateDocumentAndItsWidgetsMutation(\n  $documentId: ID!\n  $offerId: ID!\n  $teamId: ID\n) {\n  duplicateDocumentAndItsWidgets(documentId: $documentId, offerId: $offerId, teamId: $teamId) {\n    ok\n    error\n    copiedDocument {\n      name\n      _id\n      dates {\n        creation\n        lastUpdate\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "96742fc3b3a0402dd52c9e2167f34e7c";

export default node;
